/**
 * Observe elements to be marked when the viewport scrolled past them
 *
 * @todo Check how much of this can be implemented with IntersectionObserver
 * @todo https://developers.google.com/web/updates/2016/04/intersectionobserver
 * @todo https://github.com/w3c/IntersectionObserver/issues/124
 */
import ViewportOffset from "./ViewportOffset";

export default class ScrollObserver {

	static init() {
		jQuery( window ).on( 'theme:scroll', ScrollObserver.calculatePositions );
		jQuery( window ).on( 'load', function () {
			requestAnimationFrame( ScrollObserver.calculatePositions );
		} );
		jQuery( document ).ready( function() {
			ScrollObserver.addElements( '.scroll-observe' );
			jQuery( 'body' ).addClass( 'scroll-observer-ready' );
			ScrollObserver.calculatePositions();
		} );
	}

	static addElements( selector ) {
		ScrollObserver.observedElements = ScrollObserver.observedElements.add( selector );
		ScrollObserver.observedElements.each( function() {
			jQuery( this ).addClass( 'scroll-observe-active' );
		} );
	}

	static calculatePositions() {
		ScrollObserver.observedElements.each( ScrollObserver.calculateInView );
	}

	static calculateInView() {
		let $window = jQuery( window );
		let $this = jQuery( this );
		let elementTop = $this.offset().top;
		let elementBottom = elementTop + $this.outerHeight();
		let viewportTop = $window.scrollTop() + ViewportOffset.calculateOffset( $this );
		let viewportBottom = $window.scrollTop() + $window.height();
		let viewportHeight = viewportBottom - viewportTop;

		// Scroll position is past Element
		let scrolledPast = viewportTop > elementTop;
		ScrollObserver.applyClasses( $this, 'scrolled-past', scrolledPast );

		// Any part of element is in viewport
		let inView = ( elementTop < viewportBottom ) && ( elementBottom > viewportTop );
		ScrollObserver.applyClasses( $this, 'in-view', inView );

		// Determine if the element is in good position in viewport
		let inViewGood = false;
		if ( elementTop < ( viewportTop + viewportHeight / 2 )
			&& elementBottom > ( viewportBottom - viewportHeight / 2 ) ) {
			// Top is above middle and bottom is below middle, this also catches very large elements
			inViewGood = true;
		} else if ( elementTop > viewportTop
			&& elementBottom < viewportBottom ) {
			// Limits are inside viewport
			inViewGood = true;
		}
		ScrollObserver.applyClasses( $this, 'in-view-good', inViewGood );
	}

	static applyClasses( $element, viewClass, status ) {
		if ( $element.hasClass( viewClass ) !== status ) {
			$element.toggleClass( viewClass, status );
			if ( ! $element.hasClass( viewClass + '-once' ) ) {
				$element.addClass( viewClass + '-once' );
				$element.triggerHandler( 'hs:' + viewClass + '-once' );
				$element.trigger( 'theme:' + viewClass + '-once' );
			}
			if ( status ) {
				$element.triggerHandler( 'hs:' + viewClass + '-set' );
				$element.trigger( 'theme:' + viewClass + '-set' );
			} else {
				$element.triggerHandler( 'hs:' + viewClass + '-unset' );
				$element.trigger( 'theme:' + viewClass + '-unset' );
			}
		}
	}

}
ScrollObserver.observedElements = jQuery();
